import React, { useCallback, useRef, useContext } from 'react'
import { jsx, css } from '@emotion/core'
import { Button } from 'antd'
import qs from 'query-string'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'

import { SpinContext, ErrorContext } from 'context'
import { getCredentials, getAuthorization } from 'api/pgads'

const defaultRender = ({ openFile, downloadFile }) => {
  return <Button icon="cloud-download" onClick={openFile || downloadFile} />
}

const FileDownload = ({
  fileId,
  queryParams,
  apiTarget = 'file-storage/download',
  children = defaultRender,
  style,
  className,
  noTarget,
  downloadFileName,
  targetInfo,
}) => {
  const params = queryParams != null ? queryParams : { id: fileId }
  const ref = useRef()
  // const targetInfo = useContext(PmgrApiContext)
  // const [onError, errorModal] = useErrorModal()
  // const [loadingFile, setLoadingFile] = useState(false)
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const url = `${targetInfo.baseUrl}/${apiTarget}?${qs.stringify(params)}`

  const openFile = useCallback(() => {
    if (ref.current) ref.current.submit()
  }, [])

  const downloadFile = () => {
    setSpinning(true)

    fetch(url, {
      ...getCredentials(targetInfo),
      headers: getAuthorization(targetInfo),
    })
      .then(response => {
        if (response.ok) {
          return response.blob()
        } else {
          // if (response.status === 417) throw new Error('Nothing found in DB')
          throw new Error('Server Error when downloading file!!!')
        }
      })
      .then(blob => {
        var a = document.createElement('a')
        const fileURL = URL.createObjectURL(blob)
        a.href = fileURL
        a.setAttribute('download', downloadFileName)
        a.click()
        setTimeout(() => URL.revokeObjectURL(fileURL), 1000)
      })
      .catch(setError)
      .finally(() => setSpinning(false))
  }

  return (
    <div>
      {downloadFileName ? (
        <>{children({ downloadFile })}</>
      ) : (
        <form
          rel="noopener noreferrer"
          action={url}
          name="download"
          ref={ref}
          method="POST"
          style={style}
          className={className}
          target={noTarget ? undefined : '_blank'}
        >
          {children({ openFile })}
          <input type="hidden" name="jwt" value={targetInfo.jwt} />
        </form>
      )}
    </div>
  )
}
const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(FileDownload)
